import React, { useEffect } from 'react';
import BreadCrumb from 'common/breadcrumb';
import WelcomeWidget from './welcome-widget';
import OrderStatistics from './order-statistics';
import Widgets from './widgets';
import SalesRevenue from './sales-revenue';
import TrafficResources from './traffic-resources';
import ProductsOrders from './products-orders';
import CustomerService from './customer-service';
import SalesMonth from './sales-month';
import TopSellingProducts from './top-selling-products';
import Audience from './audience';
import { useNavigate } from 'react-router-dom';

const Ecommerce = () => {

    const navigate = useNavigate();
    useEffect(() => navigate("/dashboard"), [navigate]);

    return (
        <React.Fragment>
            <BreadCrumb title='Ecommerce' pageTitle='Dashboards' />
            <div className="grid grid-cols-12 gap-x-5">
                <WelcomeWidget />
                <OrderStatistics />
                <Widgets />
                <SalesRevenue />
                <TrafficResources />
                <ProductsOrders />
                <CustomerService />
                <SalesMonth />
                <TopSellingProducts />
                <Audience />
            </div>
        </React.Fragment>
    );
};

export default Ecommerce;
